import { useQuery } from "@tanstack/react-query";

import { lateFeeSummaryText } from "@/lib/fees";
import { sitePricingQuery } from "@/lib/pricing-query";

type Locale = "sv" | "en" | "es";

const LEAD: Record<Locale, string> = {
  sv: "Sen ansökningsavgift räknas från ansökningsdatumet till elevens valda startdatum:",
  en: "The late application fee is counted from the application date to the pupil’s chosen start date:",
  es: "El recargo por solicitud tardía se calcula desde la fecha de solicitud hasta la fecha de inicio elegida:",
};
const INTEREST: Record<Locale, string> = {
  sv: "Vid sen betalning debiteras dröjsmålsränta med 8 % per år.",
  en: "Late payment interest of 8 % per year is charged on overdue amounts.",
  es: "Los importes vencidos devengan intereses de demora del 8 % anual.",
};

/** Sen ansökningsavgift – beloppen byggs från nivåerna i School Harbor. */
export function LateFeeNote({ locale }: { locale: Locale }) {
  // Prenumererar så att texten uppdateras när prislistan laddats.
  useQuery(sitePricingQuery);
  const summary = lateFeeSummaryText(null, locale);
  return (
    <p>
      {summary ? `${LEAD[locale]} ${summary.charAt(0).toLowerCase()}${summary.slice(1)} ` : ""}
      {INTEREST[locale]}
    </p>
  );
}
